export default __webpack_public_path__ + "static/businesses-news-fac1118746e08e765a464e2b9d318862.jpeg";